import { CourseMaterial, ExpandedMaterialFormat } from "./coursesLoader.ts";
import { unknownPhysicalSource } from "../../../../common/features/asset/AssetCover.tsx";

export function getImageSource(material: CourseMaterial) {
  const physicalFormats: ExpandedMaterialFormat[] = [
    "print",
    "supplies",
    "print_bundle",
  ];
  if (physicalFormats.includes(material.materialFormat)) {
    return unknownPhysicalSource;
  }

  return null;
}
